export default "__VITE_ASSET__Dzv9Sbfx__"